import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

export const LOG_KEY = "pending_logs";
const MAX_LOGS = 20;

async function storeLog(entry) {
  try {
    let logs = [];
    if (Capacitor.isNativePlatform()) {
      const { value } = await Preferences.get({ key: LOG_KEY });
      logs = value ? JSON.parse(value) : [];
    } else {
      const raw = localStorage.getItem(LOG_KEY);
      logs = raw ? JSON.parse(raw) : [];
    }

    logs.push(entry);
    if (logs.length > MAX_LOGS) logs = logs.slice(-MAX_LOGS);

    const serialized = JSON.stringify(logs);
    if (Capacitor.isNativePlatform()) {
      await Preferences.set({ key: LOG_KEY, value: serialized });
    } else {
      localStorage.setItem(LOG_KEY, serialized);
    }
  } catch (_) {
    // Toujours silencieux
  }
}

function sendLog(level, context, message, data = {}) {
  storeLog({
    level,
    context,
    message,
    data,
    userAgent: navigator.userAgent,
    url: window.location.href,
    timestamp: new Date().toISOString(),
  });
}

export const logger = {
  error: (context, message, data = {}) => sendLog("error", context, message, data),
  warn:  (context, message, data = {}) => sendLog("warn",  context, message, data),
  info:  (context, message, data = {}) => sendLog("info",  context, message, data),
};
